import Main from '@/views/main.vue'

import {messagelistMenuRouter} from './messagelist'
import {messagedetailOtherRouter} from './messagedetail'

const messageMenuRouter = {
  has: 'messageConfig',
  path: '/',
  icon: 'android-people',
  name: 'messageMenuRouter',
  title: '消息配置',
  component: Main,
  children: [
    ...messagelistMenuRouter
  ]
}

const messageOtherRouter = {
  path: '/',
  name: 'messageOtherRouter',
  title: '系统通知',
  component: Main,
  children: [
    ...messagedetailOtherRouter
  ]
}

export {messageMenuRouter, messageOtherRouter}



// WEBPACK FOOTER //
// ./src/router/message/index.js